import { useLocation } from 'preact-iso';
import type { Video } from '../lib/api';
import { errorMessage } from '../lib/api';
import { formatClock, formatCount, relativeTime } from '../lib/format';
import { saveVideo } from '../lib/library';
import { useSession } from '../session';
import { Icon } from './Icon';
import { Menu } from './Menu';
import { toast } from './ui';

export function VideoCard({ v, extra }: { v: Video; extra?: string }) {
  const { me } = useSession();
  const { url, route } = useLocation();
  const needSignIn = () => route(`/login?next=${encodeURIComponent(url)}`);
  const save = async (watchLater: boolean) => {
    if (!me) return needSignIn();
    try {
      const r = await saveVideo(v, { watchLater });
      toast(watchLater ? 'Added to Watch later.' : r === 'duplicate' ? 'Already in your library.' : 'Saved to your library.');
    } catch (e) { toast(errorMessage(e), 'error'); }
  };
  return (
    <article class="video-card" data-testid="video-card">
      <a class="thumb" href={`/discover/v/${v.id}`} tabIndex={-1} aria-hidden="true">
        {v.thumbnail ? <img src={v.thumbnail} alt="" loading="lazy" referrerpolicy="no-referrer" /> : <Icon name="film" size={28} />}
        <span class="tbadges">
          {v.definition === 'hd' && <span>HD</span>}
          {v.durationSec !== null && <span>{formatClock(v.durationSec)}</span>}
        </span>
      </a>
      <div class="card-menu">
        <Menu label={`More actions for ${v.title}`} triggerClass="dots" items={[
          { label: 'Watch', icon: 'play', href: `/discover/v/${v.id}` },
          { label: me ? 'Save to library' : 'Sign in to save', icon: 'library', onSelect: () => save(false) },
          { label: 'Watch later', icon: 'clock', onSelect: () => save(true) },
          { label: 'Open on YouTube', icon: 'external', onSelect: () => { window.open(`https://www.youtube.com/watch?v=${v.id}`, '_blank', 'noopener'); } },
        ]} />
      </div>
      <a class="vtitle" href={`/discover/v/${v.id}`}>{v.title}</a>
      <span class="vmeta">{v.viewCount !== null ? `${formatCount(v.viewCount)} views` : v.channelTitle}{v.publishedAt ? ` • ${relativeTime(v.publishedAt)}` : ''}{extra ? ` • ${extra}` : ''}</span>
    </article>
  );
}
